module.exports = __webpack_public_path__ + "media/theme/wall__sidebar--recochoku-bcfe87d9.svg";